import { Stack } from "@mui/material";
import { getIconProps, ICON_SIZE } from "@pulse/shared-components";
import {
  FoundationColorTokens,
  Spacing,
  Typography as LeoTypography,
} from "@surya-digital/leo-reactjs-material-ui";
import { t } from "i18next";
import { Check } from "lucide-react";
import { observer } from "mobx-react";
import React from "react";
import { NestedTypographyComponent } from "../NestedTypographyComponent";

interface DeleteColumnDialogSuccessProps {
  spacing: Spacing;
  tokens: FoundationColorTokens<string>;
  typography: LeoTypography;
  deletedColumnName: string;
}

export const DeleteColumnDialogSuccess = observer(
  ({
    spacing,
    tokens,
    typography,
    deletedColumnName,
  }: DeleteColumnDialogSuccessProps): React.ReactElement => {
    return (
      <Stack
        gap={spacing.spaceXS}
        padding={spacing.spaceXL}
        direction="column"
        alignItems="center"
        textAlign="center"
        width="520px"
      >
        <Check {...getIconProps(tokens.iconSuccess, ICON_SIZE.large)} />
        <NestedTypographyComponent
          textColor={tokens.labelSuccess}
          startText={t("projects.deleteRespondentColumn.theColumn")}
          middleBoldText={t(
            "projects.deleteRespondentColumn.deletedColumnName",
            { deletedColumnName },
          )}
          endText={t(
            "projects.deleteRespondentColumn.hasBeenDeletedSuccessfully",
          )}
          startAndEndTextTypography={typography.b1}
          boldTextTypography={typography.s1}
          isSpan={false}
        />
      </Stack>
    );
  },
);
